module.exports = __webpack_public_path__ + "img/b8c2b29.png";